import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Color } from '../math/Color.js';

var FogExp2 = /*#__PURE__*/function () {
  function FogExp2(color) {
    var density = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.00025;

    _classCallCheck(this, FogExp2);

    this.name = '';
    this.color = new Color(color);
    this.density = density;
  }

  _createClass(FogExp2, [{
    key: "clone",
    value: function clone() {
      return new FogExp2(this.color, this.density);
    }
  }, {
    key: "toJSON",
    value: function
      /* meta */
    toJSON() {
      return {
        type: 'FogExp2',
        color: this.color.getHex(),
        density: this.density
      };
    }
  }]);

  return FogExp2;
}();

FogExp2.prototype.isFogExp2 = true;
export { FogExp2 };